'use client';
import React from 'react';
import Link from 'next/link';
import { ArticleCategoryWithArticle } from '@dr-pam/common-components/Services/Server/ArticleService';
import Loading from '@dr-pam/common-components/Components/Misc/Loading';
import useLoadTracker from '@dr-pam/common-components/Hooks/useLoadTracker';
import { IconArticle } from '@tabler/icons-react';

interface ArticleListProps {
	articles: ArticleCategoryWithArticle[];
	categorySlug: string;
	subcategorySlug: string;
}

export default function ArticleList({ articles, categorySlug, subcategorySlug }: ArticleListProps) {
	const { addLoader, hasLoader } = useLoadTracker();

	return (
		<ul className="title">
			{articles.map((categoryArticle) => (
				<li className="results-list" key={categoryArticle.article.id}>
					<IconArticle size={26} />
					<Link
						className="no-after"
						href={`/free-resources/${categorySlug}/${subcategorySlug}/${categoryArticle.article.slug}`}
						onClick={() => addLoader(categoryArticle.article.id)}
					>
						{categoryArticle.article.title}
						{hasLoader(categoryArticle.article.id) && <Loading size="small" inline />}
					</Link>
				</li>
			))}
		</ul>
	);
}
